export const services = [
  {
    slug: "persoenliche-assistenz",
    de: {
      short: "Persönliche Assistenz",
      metaTitle: "Persönliche Assistenz für Unternehmer & Familien Schweiz",
      metaDesc: "Persönliche Assistenz & Virtuelle Assistenz für Unternehmer, CEOs und Familien: Terminmanagement, Reiseplanung, Korrespondenz.",
      h1: "Persönliche Assistenz für Unternehmer & Familien",
      h1Accent: "Ihre Zeit zurückgewinnen",
      intro: [
        "Eine persönliche Assistenz ist mehr als ein Kalender-Service: Sie ist Ihre rechte Hand im Alltag. Swiss PA Services unterstützt Unternehmer, Führungskräfte, Familien und Privatpersonen in der ganzen Schweiz – vor Ort in Zug, Zürich und Umgebung oder remote als Virtual Assistant.",
        "Wir übernehmen alle Aufgaben, die Sie Zeit kosten, aber nicht voranbringen: Termin- und Kalenderverwaltung, E-Mail-Organisation, Korrespondenz, Reiseplanung mit Flug- und Hotelbuchungen, Dokumentenverwaltung und Research. So gewinnen Sie jede Woche spürbar Zeit zurück – für das, was wirklich zählt.",
      ],
      bullets: [
        "Termin- & Kalendermanagement",
        "E-Mail-Organisation & Korrespondenz",
        "Reiseplanung, Flug- & Hotelbuchungen",
        "Dokumentenverwaltung & Research",
        "Haushaltsmanagement & persönliche Erledigungen",
        "Restaurant-, Event- & Arzttermin-Reservationen",
      ],
      faq: [
        {
          q: "Was macht eine persönliche Assistenz genau?",
          a: "Eine persönliche Assistenz übernimmt organisatorische und administrative Aufgaben Ihres beruflichen und privaten Alltags: Termine, Korrespondenz, Reisen, Research und persönliche Erledigungen. Bei Swiss PA Services arbeiten Sie mit einer festen Ansprechsperson, die Ihre Gewohnheiten und Prioritäten kennt.",
        },
        {
          q: "Arbeitet der Virtual Assistant remote oder vor Ort?",
          a: "Beides ist möglich. Als Virtual Assistant arbeiten wir vollständig remote – ideal für Kunden in der ganzen Schweiz und im Ausland. In der Region Zug, Zürich und Zentralschweiz sind wir auch persönlich vor Ort für Sie da.",
        },
        {
          q: "Was kostet eine persönliche Assistenz in der Schweiz?",
          a: "Die Kosten richten sich nach Umfang und Art der Aufgaben. Wir bieten flexible Stundenpakete und monatliche Betreuungsmandate – ohne Anstellung, ohne Fixkosten. Kontaktieren Sie uns für ein unverbindliches Angebot.",
        },
        {
          q: "Kann ich eine persönliche Assistenz stundenweise buchen?",
          a: "Ja. Sie buchen uns flexibel nach Stunden – etwa für wiederkehrende Wochentage oder einzelne Projekte. Wer grössere Entlastung sucht, wählt ein monatliches Betreuungsmandat mit garantierter Verfügbarkeit.",
        },
        {
          q: "Wie schnell kann eine persönliche Assistenz bei mir starten?",
          a: "In der Regel innert weniger Tage: Nach einem kurzen Erstgespräch definieren wir Aufgaben und Prioritäten, danach startet Ihre feste Ansprechsperson. Ohne Rekrutierung, ohne Anstellungsprozess.",
        },
      ],
    },
    en: {
      short: "Personal Assistance",
      metaTitle: "Personal Assistant for Entrepreneurs & Families Switzerland",
      metaDesc: "Personal assistance & virtual assistant services for entrepreneurs, executives and families in Switzerland: diary management, travel planning.",
      h1: "Personal assistance for entrepreneurs & families",
      h1Accent: "Winning back your time",
      intro: [
        "A personal assistant is more than a calendar service: they are your right hand in everyday life. Swiss PA Services supports entrepreneurs, executives, families and private individuals across Switzerland – on site in Zug, Zurich and the surrounding area or remotely as a virtual assistant.",
        "We take over all the tasks that cost you time without moving you forward: schedule and calendar management, email organisation, correspondence, travel planning with flight and hotel bookings, document management and research. This gives you back tangible time every week – for what really matters.",
      ],
      bullets: [
        "Diary & calendar management",
        "Email organisation & correspondence",
        "Travel planning, flight & hotel bookings",
        "Document management & research",
        "Household management & personal errands",
        "Restaurant, event & appointment reservations",
      ],
      faq: [
        {
          q: "What exactly does a personal assistant do?",
          a: "A personal assistant takes over organisational and administrative tasks in your professional and private life: appointments, correspondence, travel, research and personal errands. At Swiss PA Services you work with a dedicated contact person who knows your habits and priorities.",
        },
        {
          q: "Does the virtual assistant work remotely or on site?",
          a: "Both are possible. As a virtual assistant we work fully remotely – ideal for clients across Switzerland and abroad. In the Zug, Zurich and Central Switzerland region we are also available in person.",
        },
        {
          q: "What does a personal assistant cost in Switzerland?",
          a: "Costs depend on the scope and type of tasks. We offer flexible hour packages and monthly support mandates – no employment, no fixed costs. Contact us for a non-binding quote.",
        },
        {
          q: "Can I book a personal assistant by the hour?",
          a: "Yes. You book us flexibly by the hour – for recurring weekdays or individual projects. Those seeking greater relief choose a monthly care mandate with guaranteed availability.",
        },
        {
          q: "How quickly can a personal assistant start with me?",
          a: "Usually within a few days: after a short initial conversation we define tasks and priorities, then your dedicated contact starts. No recruiting, no employment process.",
        },
      ],
    },
  },
  {
    slug: "relocation-services-schweiz",
    de: {
      short: "Relocation",
      metaTitle: "Relocation Agentur für Expats & Unternehmen Schweiz",
      metaDesc: "Relocation Services für Expats, internationale Fachkräfte und Familien: Wohnungssuche in Zürich, Zug & Genf, Anmeldung, Bewilligungen.",
      h1: "Relocation Agentur für die Schweiz",
      h1Accent: "Ihr stressfreier Umzug mit Expat-Expertise",
      intro: [
        "Ein Umzug in die Schweiz ist ein grosser Schritt – mit vielen behördlichen, administrativen und praktischen Hürden. Bei einer Leerstandsquote von teils unter einem halben Prozent ist die Wohnungssuche in Städten wie Zürich, Zug oder Genf eine echte Herausforderung. Genau hier setzen unsere Relocation Services an.",
        "Wir begleiten Expats, internationale Fachkräfte, Unternehmer und Familien durch den gesamten Prozess: von der Wohnungssuche mit begleiteten Besichtigungen über Anmeldung, Aufenthalts- und Arbeitsbewilligungen bis zu Krankenversicherung, Bankkonto und Schulberatung. Ein Ansprechpartner, alle Schritte, null Stress.",
      ],
      bullets: [
        "Wohnungssuche & begleitete Besichtigungen",
        "Anmeldung, Aufenthalts- & Arbeitsbewilligungen",
        "Krankenversicherung & Versicherungsberatung",
        "Schul- & Kinderbetreuungsberatung",
        "Bankkonto, Mobilfunk & Alltags-Setup",
        "Geprüftes Dienstleister-Netzwerk: Umzug, Reinigung, Handwerk",
      ],
      faq: [
        {
          q: "Wie finden Sie bei der tiefen Leerstandsquote eine Wohnung?",
          a: "Durch unser lokales Netzwerk aus Vermietern, Verwaltungen und Nachmieter-Kontakten erhalten wir Zugang zu Objekten, bevor sie öffentlich ausgeschrieben werden. Wir bereiten Ihre Bewerbungsdossiers professionell vor und begleiten Sie zu den Besichtigungen.",
        },
        {
          q: "Unterstützen Sie auch Familien und Expats ohne Deutschkenntnisse?",
          a: "Ja. Wir arbeiten auf Deutsch und Englisch und übernehmen die Kommunikation mit Behörden, Vermietern und Schulen vollständig für Sie. Auch Übersetzungen von Verträgen und Dokumenten gehören zu unserem Service.",
        },
        {
          q: "Was kosten Relocation Services in der Schweiz?",
          a: "Das hängt vom Umfang ab: vom einzelnen Service wie der Wohnungssuche bis zum Komplett-Paket für die ganze Familie. Nach einem kostenlosen Erstgespräch erhalten Sie eine transparente Offerte.",
        },
      ],
    },
    en: {
      short: "Relocation",
      metaTitle: "Relocation Agency for Expats & Companies Switzerland",
      metaDesc: "Relocation services for expats, international professionals and families: apartment search in Zurich, Zug & Geneva, registration, permits.",
      h1: "Relocation agency for Switzerland",
      h1Accent: "Your stress-free move with expat expertise",
      intro: [
        "Moving to Switzerland is a big step – with many bureaucratic, administrative and practical hurdles. With vacancy rates sometimes below half a percent, finding a home in cities like Zurich, Zug or Geneva is a real challenge. This is exactly where our relocation services come in.",
        "We guide expats, international professionals, entrepreneurs and families through the entire process: from the home search with accompanied viewings to registration, residence and work permits, health insurance, bank accounts and school advice. One point of contact, every step, zero stress.",
      ],
      bullets: [
        "Home search & accompanied viewings",
        "Registration, residence & work permits",
        "Health insurance & insurance advice",
        "School & childcare advice",
        "Bank account, mobile phone & everyday setup",
        "Vetted service network: movers, cleaning, craftsmen",
      ],
      faq: [
        {
          q: "How do you find a home despite the low vacancy rate?",
          a: "Through our local network of landlords, property managers and outgoing-tenant contacts, we gain access to properties before they are publicly listed. We prepare your application dossiers professionally and accompany you to the viewings.",
        },
        {
          q: "Do you also support families and expats without German skills?",
          a: "Yes. We work in German and English and handle all communication with authorities, landlords and schools for you. Translation of contracts and documents is also part of our service.",
        },
        {
          q: "What do relocation services cost in Switzerland?",
          a: "It depends on the scope: from a single service such as the home search to a complete package for the whole family. After a free initial consultation you receive a transparent quote.",
        },
      ],
    },
  },
  {
    slug: "lifestyle-concierge-schweiz",
    de: {
      short: "Lifestyle Concierge",
      metaTitle: "Lifestyle Concierge Service für Privatpersonen Schweiz",
      metaDesc: "Privater Lifestyle Concierge in Zürich, Zug & Genf: Restaurantreservationen, Luxusreisen, Eventplanung, Personal Shopping & VIP-Service.",
      h1: "Lifestyle Concierge Service",
      h1Accent: "Luxus ist, sich um nichts kümmern zu müssen",
      intro: [
        "Unser Lifestyle Concierge Service ist für Menschen, deren Zeit kostbar ist. Ob Restaurantreservation im ausgebuchten Gourmet-Tempel, die Planung einer Luxusreise, ein unvergessliches Event oder das perfekte Geschenk – wir kümmern uns um jedes Detail, bevor Sie überhaupt daran denken.",
        "Diskretion steht bei uns an erster Stelle. Viele unserer Kunden sind Unternehmer, Führungskräfte und internationale Familien, die einen vertrauenswürdigen Partner für alle privaten Angelegenheiten schätzen. Ein Anruf genügt – wir erledigen den Rest.",
      ],
      bullets: [
        "Restaurant- & Hotelreservationen",
        "Event- & Luxusreiseplanung",
        "Personal Shopping & Geschenkservice",
        "VIP-Services & besondere Anfragen",
        "Lifestyle Management & Tagesorganisation",
        "Individuelle Wünsche – diskret umgesetzt",
      ],
      faq: [
        {
          q: "Was umfasst ein Lifestyle Concierge Service?",
          a: "Alles, was Ihren Alltag angenehmer macht: Reservationen, Reise- und Eventplanung, Personal Shopping, Geschenke und individuelle Wünsche jeder Art. Wenn es organisierbar ist, organisieren wir es.",
        },
        {
          q: "Wie kurzfristig können Sie Anfragen umsetzen?",
          a: "Sehr kurzfristig. Dank unseres Netzwerks in der Schweiz und international realisieren wir auch Last-Minute-Reservationen, Tickets oder Reiseänderungen. Ihre Anfrage wird persönlich und prioritär behandelt.",
        },
        {
          q: "Wie diskret ist der Concierge Service?",
          a: "Absolute Diskretion ist die Grundlage unserer Arbeit. Alle Anfragen werden vertraulich behandelt, Daten werden nicht weitergegeben. Auf Wunsch arbeiten wir mit Verschwiegenheitserklärungen.",
        },
        {
          q: "Was kostet ein Lifestyle Concierge in der Schweiz?",
          a: "Einmalige Concierge-Aufträge rechnen wir transparent nach Aufwand ab; für laufende Betreuung empfehlen wir ein monatliches Mandat. Nach einem unverbindlichen Erstgespräch erhalten Sie eine klare Offerte – ohne versteckte Kosten.",
        },
        {
          q: "Für wen lohnt sich ein privater Concierge Service?",
          a: "Für alle, deren Zeit knapper ist als ihre Möglichkeiten: Unternehmer, Führungskräfte, Familien und Expats, die Reservationen, Reisen, Events und Erledigungen auslagern wollen – an eine feste Ansprechsperson statt an wechselnde Hotlines.",
        },
      ],
    },
    en: {
      short: "Lifestyle Concierge",
      metaTitle: "Private Lifestyle Concierge Service Switzerland",
      metaDesc: "Private lifestyle concierge in Zurich, Zug & Geneva: restaurant reservations, luxury travel, event planning, personal shopping & VIP service.",
      h1: "Lifestyle Concierge Service",
      h1Accent: "Luxury is not having to worry about a thing",
      intro: [
        "Our lifestyle concierge service is for people whose time is precious. Whether a reservation at a fully booked gourmet restaurant, planning a luxury trip, an unforgettable event or the perfect gift – we take care of every detail before you even think of it.",
        "Discretion comes first. Many of our clients are entrepreneurs, executives and international families who value a trusted partner for all private matters. One call is all it takes – we handle the rest.",
      ],
      bullets: [
        "Restaurant & hotel reservations",
        "Event & luxury travel planning",
        "Personal shopping & gift service",
        "VIP services & special requests",
        "Lifestyle management & day organisation",
        "Individual wishes – handled discreetly",
      ],
      faq: [
        {
          q: "What does a lifestyle concierge service include?",
          a: "Everything that makes your daily life more enjoyable: reservations, travel and event planning, personal shopping, gifts and individual wishes of every kind. If it can be organised, we organise it.",
        },
        {
          q: "How quickly can you handle requests?",
          a: "Very quickly. Thanks to our network in Switzerland and abroad, we also handle last-minute reservations, tickets or travel changes. Your request is treated personally and with priority.",
        },
        {
          q: "How discreet is the concierge service?",
          a: "Absolute discretion is the foundation of our work. All requests are treated confidentially and data is never shared. On request, we work with non-disclosure agreements.",
        },
        {
          q: "How much does a lifestyle concierge cost in Switzerland?",
          a: "One-off concierge requests are billed transparently by effort; for ongoing care we recommend a monthly mandate. After a non-binding first conversation you receive a clear proposal – no hidden costs.",
        },
        {
          q: "Who is a private concierge service for?",
          a: "For anyone whose time is scarcer than their options: entrepreneurs, executives, families and expats who want to outsource reservations, travel, events and errands – to one dedicated contact instead of changing hotlines.",
        },
      ],
    },
  },
  {
    slug: "home-property-management",
    de: {
      short: "Property Management",
      metaTitle: "Zweitwohnsitz Betreuung & Home Watch Schweiz",
      metaDesc: "Home & Property Management für Privatpersonen: Zweitwohnsitz- & Ferienhausverwaltung am Zürichsee, Zugersee und in den Alpen, Home-Watch-Kontrollen.",
      h1: "Home & Property Management Schweiz",
      h1Accent: "Zweitwohnsitz-Betreuung & Home Watch Service",
      intro: [
        "Ob Hauptwohnsitz, Zweitwohnsitz oder Ferienresidenz: Eine Liegenschaft will betreut sein – auch und gerade in Ihrer Abwesenheit. Swiss PA Services übernimmt die private Immobilienbetreuung in der Schweiz: von regelmässigen Home-Watch-Kontrollen über die Koordination von Hauspersonal und Handwerkern bis zum gesamten Liegenschaftsunterhalt.",
        "Wir behandeln jede Liegenschaft, als wäre es unsere eigene. Mit diskreten Abwesenheitskontrollen, Werterhalt-Management und transparentem Reporting wissen Sie jederzeit, dass Ihr Zuhause – in Zug, Zürich, am Zürichsee oder in den Bergen – in besten Händen ist.",
      ],
      bullets: [
        "Home Watch: regelmässige Kontrollgänge & Abwesenheitsbetreuung",
        "Zweitwohnsitz- & Ferienhausverwaltung Schweiz",
        "Koordination von Hauspersonal, Gärtnern & Handwerkern",
        "Liegenschaftsunterhalt & Werterhalt-Management",
        "Schlüsselverwaltung & Key-Holding-Service",
        "Vorbereitung bei An- & Abreise, Begrüssungsservice",
        "Ferienbewachung & Kontrollen während Ihrer Abwesenheit",
        "Liegenschaftsadministration & transparentes Reporting",
      ],
      faq: [
        {
          q: "Was umfasst Home & Property Management?",
          a: "Die komplette Betreuung Ihrer Liegenschaft: regelmässige Home-Watch-Kontrollgänge, Koordination von Hauspersonal, Handwerkern und Gärtnern, Schlüsselverwaltung, Unterhaltsplanung und Werterhalt. Sie erhalten ein transparentes Reporting zu allen Tätigkeiten.",
        },
        {
          q: "Betreuen Sie auch Zweitwohnsitze und Ferienresidenzen?",
          a: "Ja, das ist eine unserer Kernleistungen. Wir betreuen Zweitwohnsitze und Ferienresidenzen in der ganzen Schweiz – am Zürichsee, Zugersee, Vierwaldstättersee und in den Alpen – inklusive Abwesenheitskontrollen, Vorbereitung vor Ihrer Ankunft und Einwintern nach Ihrer Abreise.",
        },
        {
          q: "Wie funktioniert die Zusammenarbeit mit Hauspersonal und Handwerkern?",
          a: "Wir rekrutieren, koordinieren und kontrollieren Hauspersonal und Dienstleister für Sie. Sie haben nur einen Ansprechpartner: uns. Alle Termine, Qualitätskontrollen und Abrechnungen laufen über Swiss PA Services.",
        },
        {
          q: "Was ist der Unterschied zwischen Home & Property Management und einer klassischen Hausverwaltung?",
          a: "Die klassische Hausverwaltung betreut Mietliegenschaften und Stockwerkeigentum. Wir kümmern uns um Ihre private Immobilie aus Eigentümersicht: Werterhalt, Kontrollgänge, Hauspersonal, Handwerker und die Vorbereitung für Ihre Ankunft – persönlich und diskret.",
        },
        {
          q: "Wie oft empfehlen Sie Home-Watch-Kontrollgänge?",
          a: "Je nach Objekt und Versicherungsvorgaben wöchentlich bis monatlich. Manche Versicherungen verlangen bei leerstehenden Objekten wöchentliche Kontrollen – wir stimmen den Rhythmus auf Ihre Police und Ihre Abwesenheit ab.",
        },
      ],
    },
    en: {
      short: "Property Management",
      metaTitle: "Second Home Management & Home Watch Switzerland",
      metaDesc: "Private property management in Switzerland: second home & vacation home management on Lake Zurich and in the Alps, home watch inspections.",
      h1: "Home & Property Management Switzerland",
      h1Accent: "Second home care & home watch service",
      intro: [
        "Whether primary residence, second home or holiday estate: a property needs looking after – especially in your absence. Swiss PA Services provides private property care in Switzerland: from regular home-watch inspections to coordinating household staff and contractors through to complete property maintenance.",
        "We treat every property as if it were our own. With discreet absence checks, value-preservation management and transparent reporting, you always know your home – in Zug, Zurich, on Lake Zurich or in the mountains – is in the best hands.",
      ],
      bullets: [
        "Home watch: regular inspections & absence care",
        "Second home & vacation home management Switzerland",
        "Coordination of household staff, gardeners & contractors",
        "Property maintenance & value preservation",
        "Key holding & access management",
        "Arrival & departure preparation, welcome service",
        "Vacation home watch & checks while you are away",
        "Property administration & transparent reporting",
      ],
      faq: [
        {
          q: "What does home & property management include?",
          a: "Complete care of your property: regular home-watch walk-throughs, coordination of household staff, craftsmen and gardeners, key holding, maintenance planning and value preservation. You receive transparent reporting on all activities.",
        },
        {
          q: "Do you also look after second homes and holiday residences?",
          a: "Yes, that is one of our core services. We look after second homes and holiday residences across Switzerland – on Lake Zurich, Lake Zug, Lake Lucerne and in the Alps – including absence checks, preparation before your arrival and closing down after your departure.",
        },
        {
          q: "How does the cooperation with household staff and craftsmen work?",
          a: "We recruit, coordinate and supervise household staff and service providers for you. You have only one point of contact: us. All appointments, quality checks and invoices run through Swiss PA Services.",
        },
        {
          q: "What is the difference between home & property management and a traditional property administrator?",
          a: "A traditional administrator manages rental buildings and condominiums. We look after your private property from the owner's perspective: value preservation, inspection visits, household staff, tradespeople and preparation for your arrival – personal and discreet.",
        },
        {
          q: "How often do you recommend home watch visits?",
          a: "Depending on the property and insurance requirements, weekly to monthly. Some insurers require weekly checks for unoccupied homes – we align the rhythm with your policy and your absence.",
        },
      ],
    },
  },
  {
    slug: "executive-family-assistance",
    de: {
      short: "Executive & Family Assistance",
      metaTitle: "Executive Assistant für CEOs & Unternehmer Schweiz",
      metaDesc: "Executive & Family Assistance für CEOs, Unternehmer und Family Offices: C-Level Support, Familienassistenz.",
      h1: "Executive & Family Assistance",
      h1Accent: "Entlastung für CEOs, Unternehmer & Familien",
      intro: [
        "Erfolgreiche Unternehmer und Führungskräfte brauchen Entlastung auf beiden Seiten: im Business und zu Hause. Unsere Executive & Family Assistance verbindet klassischen Executive Support mit der kompletten Organisation Ihres Familienalltags – diskret, mehrsprachig und immer einen Schritt voraus.",
        "Von der Familienkalender-Koordination über Schul- und Betreuungsthemen bis zur Zusammenarbeit mit Ihrem Family Office, Ihren Beratern und Banken: Swiss PA Services ist die Schnittstelle, die alles zusammenhält.",
      ],
      bullets: [
        "Executive Support auf C-Level",
        "Familienorganisation & Familienkalender",
        "Schul-, Kinder- & Betreuungskoordination",
        "Haushalts- & Personaladministration",
        "Reise- & Eventmanagement für Familien",
        "Schnittstelle zu Family Office, Beratern & Banken",
      ],
      faq: [
        {
          q: "Was ist der Unterschied zwischen Executive und Family Assistance?",
          a: "Executive Assistance entlastet Sie beruflich: Agenda, Reisen, Korrespondenz, Projekte. Family Assistance organisiert Ihr Privat- und Familienleben: Haushalt, Kinder, Termine, Ferien. Bei uns erhalten Sie beides aus einer Hand – perfekt aufeinander abgestimmt.",
        },
        {
          q: "Arbeiten Sie mit Family Offices zusammen?",
          a: "Ja. Wir sind regelmässig als operative Schnittstelle für Family Offices tätig und koordinieren Lifestyle-, Immobilien- und Alltagsthemen für deren Klienten – selbstverständlich unter absoluter Diskretion und auf Wunsch mit NDA.",
        },
        {
          q: "Können Sie auch kurzfristig einspringen?",
          a: "Ja. Ob Vertretung bei Abwesenheit Ihrer bestehenden Assistenz, ein zeitkritisches Projekt oder eine akute Familiensituation – wir sind flexibel und kurzfristig für Sie da.",
        },
      ],
    },
    en: {
      short: "Executive & Family Assistance",
      metaTitle: "Executive Assistant for CEOs & Entrepreneurs Switzerland",
      metaDesc: "Executive & family assistance for CEOs, entrepreneurs and family offices in Switzerland: C-level support, family organisation.",
      h1: "Executive & Family Assistance",
      h1Accent: "Support for CEOs, entrepreneurs & families",
      intro: [
        "Successful entrepreneurs and executives need support on both sides: in business and at home. Our Executive & Family Assistance combines classic executive support with the complete organisation of your family life – discreet, multilingual and always one step ahead.",
        "From family calendar coordination to school and childcare matters and cooperation with your family office, advisers and banks: Swiss PA Services is the interface that holds everything together.",
      ],
      bullets: [
        "C-level executive support",
        "Family organisation & family calendar",
        "School, children & care coordination",
        "Household & staff administration",
        "Travel & event management for families",
        "Interface to family office, advisers & banks",
      ],
      faq: [
        {
          q: "What is the difference between executive and family assistance?",
          a: "Executive assistance supports you professionally: diary, travel, correspondence, projects. Family assistance organises your private and family life: household, children, appointments, holidays. With us you get both from a single source – perfectly aligned.",
        },
        {
          q: "Do you work with family offices?",
          a: "Yes. We regularly act as an operational interface for family offices, coordinating lifestyle, property and everyday matters for their clients – always with absolute discretion and under NDA if desired.",
        },
        {
          q: "Can you step in at short notice?",
          a: "Yes. Whether covering for your existing assistant, a time-critical project or an urgent family situation – we are flexible and available at short notice.",
        },
      ],
    },
  },
];

export default services;
